import { render, staticRenderFns } from "./RushPlayerLink.vue?vue&type=template&id=5fb165ae&"
import script from "./RushPlayerLink.vue?vue&type=script&lang=js&"
export * from "./RushPlayerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports